import React, { createContext, useContext, useState, useMemo, useEffect } from "react";
import { translations } from "./translations";

const LangContext = createContext(null);
const SUPPORTED = ["it", "en", "de", "fr", "ru"];

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "it";
    const stored = window.localStorage?.getItem("zitro-lang");
    if (stored && SUPPORTED.includes(stored)) return stored;
    const browser = (window.navigator?.language || "").slice(0, 2).toLowerCase();
    return SUPPORTED.includes(browser) ? browser : "it";
  });

  const setLang = (next) => {
    if (!SUPPORTED.includes(next)) return;
    setLangState(next);
    try { window.localStorage?.setItem("zitro-lang", next); } catch {}
  };

  useEffect(() => {
    if (typeof document !== "undefined") document.documentElement.lang = lang;
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      setLang,
      t: translations[lang] || translations.it,
    }),
    [lang]
  );
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang outside provider");
  return ctx;
};
